import { render, staticRenderFns } from "./Originators.vue?vue&type=template&id=3a7bf7eb&"
import script from "./Originators.vue?vue&type=script&lang=ts&"
export * from "./Originators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports